import { createTextFileAndDownload } from './files'

export { createTextFileAndDownload };

export const NULLUID = '0000-0000-0000-0000';

export function emailIsValid (email) {
  /*  
  Credit: 
  How to validate an email address in JavaScript
  Tyler McGinnis
  https://tylermcginnis.com/validate-email-address-javascript/
  */
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}  

export function cloned(obj) {
  return JSON.parse(JSON.stringify(obj))
} 

export function randint(min, max) {
  return parseInt(min + Math.floor((max - min) * Math.random()))
}

export function randid() {
  /**
   * Returns a randomized ID of the form 'idXXXX'
   * where X is a Hexa digit (0..F)
   * @returns: string idXXXX
   */
  return 'id'+(randint(0, 65535).toString(16))
}

export function prettyDate(o) {
  /**
   * Formats date as '12 May 2020'.
   * If year is current does not show the year.
   */
  const months= [
    'Ene','Feb','Mar','Abr','May','Jun',
    'Jul','Ago','Sep','Oct','Nov','Dic'
  ];
  let d = o || (new Date()) // received date or today
  d = (typeof(d) === 'string') ? new Date(d) : d ;
  var mo= d.getMonth() ;
  var yy= d.getFullYear() ;
  var da= d.getDate() ;
  let today = new Date()
  return (
    (da < 10 ? ' '+da : da)
    +(' '+months[mo])
    +(today.getFullYear() === yy ? '' : ' '+yy)
  )
}

export function prettyTime(o) {
  let d = o || new Date(); // received date or today
  d = (typeof(d) === 'string') ? new Date(d) : d ;
  var ho= d.getHours() ;
  var min= d.getMinutes() ;
  return (ho < 10 ? ' '+ho : ho)+":"+(min < 10 ? ' '+min : min);
}

export function prettyDateTime(o) {
  return prettyDate(o)+" "+prettyTime(o) ;
}

export function copyAttrsOnly(to, from) {
  /**
   * Copies only first level attrs,
   * it does not copy recursively,
   * only attrs existing in 'to' obj
   */
  if (! from)
    return to

  // only keys in 'to' obj
  Object.keys(to).map((key) => {

    if (from[key] === undefined) 
      return ;

    // do not copy functions !
    if (typeof(to[key]) === 'function')
      return ;

    // clone object (serializing it)
    if (typeof(to[key]) === 'object') {
      to[key] = cloned(from[key]) ;
      return ;  
    }

    // all other types
    to[key] = from[key] ;
    return ;
  })

  return to
}

export function sortIt (v) {
  /**
   * Ordena en forma alfabetica un vector de opciones { value, text }
   * pero normalizando el texto a comparar, primero pasando todo a mayúsculas
   * y luego reemplazando chars acentuados por sus equivalente no acentuados.
   */

  function normalize (tx) {
    return tx.toUpperCase()
      .replace('Á', 'A')
      .replace('É', 'E')
      .replace('Í', 'I')
      .replace('Ó', 'O')
      .replace('Ú', 'U')
      .replace('Ñ', 'N')
  }

  return v.sort(function (a, b) {
    const xa = normalize(a.text)
    const xb = normalize(b.text)
    if (xa > xb) {
      return 1
    }
    if (xa < xb) {
      return -1
    }
    // a must be equal to b
    return 0
  })
}


export function hashedArray(arr, attr) {
  /**
   * Converts items of an array ob objs 
   * in a set hashed by the requested obj attr.
   * @arr: the array of objects.
   * @attr: the attr to be used as the hash key. 
   * @returns: a hash indexed by attr.
   */
  let hash = {};
  (arr || []).map((t) => {
    hash[ t[attr] ] = cloned(t); 
  });
  return hash;
}


export function CustomException(code, text) {
  /**
   * Defines a Custom exception to be returned 
   * by methods when throwing app exceptions.
   */
  this.code = code;
  this.text = text;
}


export function microTemplate(str, obj) {
  /** 
   * Microtemplate que convierte un string que contiene variables a reemplazar
   * de la forma #varname y devuelve el string reemplazado. Los valores se
   * extraen del objeto recibido.
   */
  // if no pattern (null, undefined, empty) just return empty string
  if (!str) return "";

  // primero cambiar "#varname" por "[[varname]]"
  var regex = /\#([a-zA-Z0-9_\~]*)/gi;
  str = str.replace(regex, "[[$1]]");

  var i = str.indexOf('[[');
  var original = str;

  while (i != -1) {
    var j = str.indexOf(']]', i);
    var varname = str.substring(i + 2, j);

    // veamos si es varname complejo
    // como por ej: #section_9~0~entero_35
    if (varname.indexOf('~') > 0) {
      // tiene varias partes, asumimos que es un Array
      var parts = varname.split('~');
      if (parts.length == 2) {
        // is a nested object
        var value = obj[parts[0]][parts[1]];
      } else if (parts.length == 3) {
        // is an object inside an array
        var value = obj[parts[0]][parts[1]][parts[2]];
      } else {
        // nothing we can do !!
        value = undefined;
      }
      if (typeof (value) == "object" && value !== null) {
        if (value.descr !== undefined)
          value = value.descr // esperemos que exista !!!
        else
          value = (value !== undefined) ?
          value.toString() // algo resultara ???
          :
          "";
      }

      original = original.replace('[[' + varname + ']]', value);
    } else {
      // es un objeto comun
      if (varname in obj) {
        var value = obj[varname];
        if (typeof (value) == "object") {
          if (value.descr !== undefined)
            value = value.descr // esperemos que exista !!!
          else
            value = value.toString(); // algo resultara ???
        }

        original = original.replace('[[' + varname + ']]', value);
      }
    }

    i = str.indexOf('[[', j - 1);
  }

  return original;
}

// Date utilities
export function dateToISO (date) {
  // Formatea a string en formato YYYY-MM-DD
  var dd = date.getDate()
  var mm = date.getMonth() + 1
  var yyyy = date.getFullYear()
  return(
    yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + dd
    + ' 00:00:00'
  ) 
}


export function toVarName(s) {
  /**
   * Convert a string with any chars to a valida SQL/JS variable name.
   * @s: the string to convert, ej: "Humedad en %"
   * @returns: the sanitized var name, ex: "humedad_en_pct"
   */
  return s.toLowerCase()
    .replace(/ñ/g,'n')
    .replace(/á/g,'a')
    .replace(/é/g,'e')
    .replace(/í/g,'i')
    .replace(/ó/g,'o')
    .replace(/ú/g,'u')
    .replace(/__/g, '')
    .replace(/ /g, '_')
    .replace(/\-/g, '_')
    .replace(/\//g, '_')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\./g, '')
    .replace(/\°/g, 'gr')
    .replace(/\%/g, 'pct')
    .replace(/\$/g, 'um')
    .replace(/\"/g, '')
    .replace(/\'/g, '')
    .replace(/\|/g, '')
    .replace(/\#/g, '')
    .replace(/\&/g, '')
    .replace(/\=/g, '')
    .replace(/\?/g, '')
    .replace(/\¿/g, '')
    .replace(/\!/g, '')
    .replace(/\¡/g, '')
    .replace(/\+/g, '')
    .replace(/\*/g, '')
    .replace(/\{/g, '')
    .replace(/\}/g, '')
    .replace(/\[/g, '')
    .replace(/\]/g, '')
    .replace(/\~/g, '')
    .replace(/\,/g, '')
    .replace(/\;/g, '')
    .replace(/\./g, '')
    .replace(/\:/g, '')
    .replace(/\@/g, '')
    .trim()
    .replace(/_/, (s) => s[s.length-1]==='_' ? s.slice(0,-1) : s) // delete last '_'
    .substring(0,62) // long max del varname para SQL
  }


export function slugify(text) {
  /**
   * Credits: 
   * https://gist.github.com/mathewbyrne
   * https://gist.github.com/mathewbyrne/1280286
   * @MAZito - fixes for accents and special chars, no digits at start, etc
   */
  let s= text.toString().toLowerCase().trim()
    .replace(/ñ/g,'n')              // Spanish chars
    .replace(/á/g,'a')
    .replace(/é/g,'e')
    .replace(/í/g,'i')
    .replace(/ó/g,'o')
    .replace(/ú/g,'u')
    .replace(/\°/g, 'gr')           // Abbreviations frequently used
    .replace(/\%/g, 'pct')
    .replace(/\$/g, 'um')
    .replace(/\s+/g, '_')           // Replace spaces with -
    .replace(/\-+/g, '_')           // Replace dash with _
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\_+/g, '_')           // Replace multiple - with single -
    .replace(/^_+/, '')             // Trim - from start of text
    .replace(/_+$/, '')             // Trim - from end of text
    .replace(/^\d/, "x$&");         // Add 'x' to start if starts with digit
  return(s.substring(0,62));        // truncate to max length name for SQL 
}
